import http from 'common/http'

export function fetchResellers(page = 1, pageSize = 10, search = '') {
  return http.get('/reseller', {
    params: {
      page,
      pageSize,
      search: search || undefined,
    },
  })
}

export function editReseller(id: string, data: any) {
  return http.put(`/reseller/${id}`, data)
}

export function fetchEligibleTenants(search = '', page = 1, pageSize = 20) {
  return http.get('/reseller/eligible-tenants', {
    params: {
      search: search || undefined,
      page,
      pageSize,
    },
  })
}

export function createReseller(tenantId: string) {
  return http.post('/reseller', { tenantId })
}
